import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { MONTH_NAMES } from '../constants';

const OV = { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const MO = { background: '#fff', borderRadius: 8, maxWidth: 360, width: 'calc(100% - 32px)' };
const MH = { padding: '14px 20px', borderBottom: '1px solid #e5e7eb' };
const MB = { padding: '16px 20px', fontSize: '0.875rem', color: '#374151', lineHeight: 1.6 };
const MF = { padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end' };
const BP = { padding: '6px 16px', borderRadius: 4, border: 'none', backgroundColor: '#1976d2', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500 };

const NoHoursWarningDialog = React.memo(function NoHoursWarningDialog({
  open, onClose, day, month, year,
}) {
  if (!open) return null;
  const dateLabel = `${day} ${MONTH_NAMES[month]} ${year}`;
  return (
    <div style={OV} onClick={onClose}>
      <div style={MO} onClick={(e) => e.stopPropagation()}>
        <div style={MH}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <WarningAmberIcon style={{ fontSize: 20, color: '#f59e0b' }} />
            <span style={{ fontWeight: 600, fontSize: '1rem' }}>ยังไม่ได้ลงเวลา</span>
          </div>
        </div>
        <div style={MB}>
          วันที่ {dateLabel} ยังไม่มีการลงเวลาทำงาน
          <br />
          กรุณาลงเวลาในวันที่ {dateLabel} ก่อน จึงจะสามารถเพิ่ม OT ได้
        </div>
        <div style={MF}>
          <button style={BP} onClick={onClose}>รับทราบ</button>
        </div>
      </div>
    </div>
  );
});

export default NoHoursWarningDialog;
